import store from "../redux/store";
import { handleJoiSchemaError, getCompanyIdFromDomain } from "../utils";
import { logMediumError } from "../utils/logger";
import { API_SHOP_ADDRESS, API_SHOPS, API_GET_SHOP_ORDER_SLOTS } from "./api";
import { sendGetRequest } from "./backend";

export const getAllShops = async () => {
  const configurationReducer = store.getState().configurationReducer;
  const companyId = configurationReducer?.companyId ?? getCompanyIdFromDomain();
  try {
    const response = await sendGetRequest(API_SHOPS(companyId), null, false);

    return response.data;
  } catch (error) {
    logMediumError(
      `Failed to get all shop from company (${companyId})  ${handleJoiSchemaError(
        error
      )}`
    );
  }
};

export const getShopAddress = async (shopId: string) => {
  const configurationReducer = store.getState().configurationReducer;
  const companyId = configurationReducer?.companyId ?? getCompanyIdFromDomain();
  try {
    const response = await sendGetRequest(
      API_SHOP_ADDRESS(companyId, shopId),
      null,
      false
    );

    return response.data;
  } catch (error) {
    logMediumError(
      `Failed to get shop (${shopId}) address from company (${companyId})  ${handleJoiSchemaError(
        error
      )}`,
      { shopId }
    );
  }
};

export const fetchShopOrderSlots = async (
  companyId: string,
  customerId: string,
  orderDate: string,
  timezone: string
): Promise<any[]> => {
  try {
    const baseUrl = API_GET_SHOP_ORDER_SLOTS(companyId, customerId);
    const params = new URLSearchParams({ orderDate, timezone });
    const url = `${baseUrl}?${params.toString()}`;

    const response = await sendGetRequest(url, null, false);
    return response?.data ?? [];
  } catch (error: any) {
    logMediumError(
      `Error fetching shop order slots for companyId=${companyId}, userId=${customerId}, orderDate=${orderDate}, timezone=${timezone}: ${handleJoiSchemaError(
        error
      )}`,
      { companyId, customerId, orderDate, timezone }
    );
    return [];
  }
};
